import { render } from "./SectionAddView.vue?vue&type=template&id=4e656398"
import script from "./SectionAddView.vue?vue&type=script&lang=js"
export * from "./SectionAddView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__